export enum PriceRequestTypesEnum {
  PC = 'PC',
  WPP = 'WPP',
  NP = 'NP'
}
